import BooleanFilter from "@search/store/filters/primitive/BooleanFilter";

class FlightsFilter extends BooleanFilter {
  constructor(value: boolean) {
    super({
      defaultValue: false,
      label: "Flights",
      name: "flights",
      value,
    });
  }
}

export default FlightsFilter;
export { FlightsFilter };
